var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"close-header-title"},[_c('a',{staticClass:"scrollup",staticStyle:{"display":"none"},attrs:{"href":"javascript:void(0);"}},[_c('i',{staticClass:"ion-ios-arrow-up"})])])
}]

export { render, staticRenderFns }